import classNames from "classnames";
import React, { useEffect } from "react";
import CountUp from "react-countup";
import { gameHooks } from "../../hooks/queries/useGame";
import { IUpdateGameScoreRequest } from "../../types/api";
import Avatar from "../common/Avatar/Avatar";
import Button from "../common/Button/Button";
import ProgressBar from "../common/ProgressBar/ProgressBar";
import styles from "./GameOver.module.scss";

interface IGameOverProps {
  isGameOver: boolean;
  onRestart: () => void;
  onExit: () => void;
  gameData: IUpdateGameScoreRequest;
  highScore?: number;
  userName?: string;
}

const GameOver: React.FC<IGameOverProps> = ({
  isGameOver,
  onRestart,
  onExit,
  gameData,
  highScore = 0,
  userName = "Guest Player",
}) => {
  const {
    mutate: addPacmanLog,
    isPending: isAddingPacmanLog,
    isError: isAddPacmanLogError,
    error: addPacmanLogError,
  } = gameHooks.useGame();

  useEffect(() => {
    // Only call API if it hasn't been called yet and gameData exists
    if (isGameOver && gameData) {
      addPacmanLog(gameData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGameOver]);

  if (!isGameOver) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h1 className={styles.titleText}>Game Over</h1>
        <p className={styles.titleDescription}>You lost all your lives</p>
      </div>

      <div className={styles.profileContainer}>
        {isAddingPacmanLog ? (
          <ProgressBar progress={30} showPercentage={false} />
        ) : isAddPacmanLogError ? (
          <p className={classNames(styles.errorText, "text2-base-500 ")}>
            {addPacmanLogError.message}
          </p>
        ) : (
          <>
            <Avatar size="large" />
            <p className="text2-base-700">{userName}</p>
            <p className={classNames(styles.scoreText, "text1-h2-700")}>
              <CountUp end={gameData?.score || 0} duration={2} />
            </p>
            <p className="text2-base-500">
              High score: {highScore.toLocaleString()}
            </p>
          </>
        )}
      </div>
      <div className={styles.actionContainer}>
        <Button onClick={onRestart}>Restart</Button>
        <Button onClick={onExit}>Exit Game</Button>
      </div>
    </div>
  );
};

export default GameOver;
